import { render, staticRenderFns } from "./payment_account.vue?vue&type=template&id=2366ff0a&scoped=true&"
import script from "./payment_account.vue?vue&type=script&lang=js&"
export * from "./payment_account.vue?vue&type=script&lang=js&"
import style0 from "./payment_account.vue?vue&type=style&index=0&id=2366ff0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2366ff0a",
  null
  
)

component.options.__file = "payment_account.vue"
export default component.exports